<template>
    <div>
        <div v-if="!loading" class="bg-img-1">
          <banner title="Notices"></banner>
          <section class="agency blog blog-sec blog-list">
            <div class="container">
              <div class="row">

                <div class="col-12 blog-sec blog-list" v-for="(notice,index) in notices" :key="index">
                  <div class="d-flex gap-2 w-100">
                    <div class="row w-100 bg-white rounded">
                      <div class="col-xl-12 col-lg-12 col-md-12 p-0">
                        <div class="img-container">
                          <div class="">
                            <div class="blog-info">
                              <div class="m-b-20">
                                <div class="align-items-center" style="display: flex;">
                                  <i aria-hidden="true" class="fa fa-clock-o m-r-10 text-secondary" style="font-size: 19px;"></i>
                                  <h6 class="m-r-25 font-blog  text-secondary">{{formatDateTime(notice.upload_time)}}</h6>
                                </div>
                              </div>
                              <a target="_blank" :href="notice.file_path">
                                <h5 class="blog-head font-600" style="color:#3f477f;font-family: 'kalpurush'">
                                  {{notice.title}}
                                </h5>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
        </div>
        <div v-else>
            <loader class="loader"></loader> <br />
        </div>
        <div class="tap-top">
            <div><i v-on:click="topFunction()" class="fa fa-angle-double-up"></i></div>
        </div>
    </div>
</template>

<script>
import Loader from '../Helper/Loader'
// import VuePdfApp from "vue-pdf-app";
import toastr from "vue-toastr";
// import this to use default icons for buttons
// import "vue-pdf-app/dist/icons/main.css";
// import Advantage from './Advantage'
// import Contact from './Contact'
// import PageFooter from '../Partial/Footer'
import Banner from '../Partial/Banner'
// import LatestNews from '../Partial/LatestNews'
// import Login from '../Auth/Login'
import { GET_DOCS } from '../../const/api'
import { GET } from '../../utils/Request'

export default {
  name: 'Notice',
  components: { Loader, Banner },
  data() {
    return {
        loading: true,
        firstTimeLoad: true,
        notices:null
    }
  },
  computed: {
    isOnHomepage() {
      let routeName = this.$route.name
      return routeName == 'home' ? true : false
    }
  },
  created() {
    this.getNotices();
  },
  mounted() {   
  },
  methods: {
    async getNotices() {
      var data = await GET(GET_DOCS);
      this.notices = data.data.data.notices;
      // console.log(this.notices);
      this.timeoutForLoading();
    },
    pagesRendered(pdfApp) {
      setTimeout(() => (pdfApp.pdfViewer.currentScaleValue = "page-height"));
    },
    goForUrl(url) {
      this.$router.replace(url)
    },
    showT(){
this.toastr.s("SUCCESS MESSAGE", "Success Toast Title");
    },
    topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    },
    timeoutForLoading() {
      if (this.firstTimeLoad) {
        this.$nextTick(() => {
          setTimeout(
            function() {
              this.loading = false
            }.bind(this),
            1000
          )
        })
      }
      this.firstTimeLoad = false
    },
    formatDateTime(datetime) {
      if (!datetime) return '';

      const date = new Date(datetime);

      // Hours & Minutes
      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; // convert 0 -> 12 for 12AM

      // Day, Month, Year
      const day = date.getDate().toString().padStart(2, '0');
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();

      return `${hours}:${minutes} ${ampm} ${day} ${month}, ${year}`;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader {
  margin-top: 20%;
}
.pdf-app{
  width:100%;
  height:100vh;
}
.d-flex{
  padding:10px;
  margin:10px;
  /* -webkit-box-shadow: 1px 0 15px 2px #c1b3b3; */
    /* box-shadow: 1px 0 15px 2px #c1b3b3; */
}
.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid{
  max-width:100%;
}

.bg-img-1{
    position: relative;
    background: url('../../theme-assets/images/event/cu_front_gate.jpg');
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
}

.bg-img-1::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: linear-gradient(#71afc7, #212121);
  opacity: 0.8;
  mix-blend-mode: multiply; /* deepens the tone */
  z-index: 1;
}

/* Make sure the content stays above the overlay */
.bg-img-1 > * {
  position: relative;
  z-index: 2;
}
/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
	 box-sizing: border-box;
}

</style>
